import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Enrollment", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "mdm-white-panel mdm-overflow-x" }

import { MdmPolicySchema } from '@/generated/sdk'
import { computed } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyEnrollment',
  setup(__props) {

const store = useStore()
const policy = computed<MdmPolicySchema>(() => store.state.policies.currentPolicy)

return (_ctx: any,_cache: any) => {
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_QrCode = _resolveComponent("QrCode")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DodoRow, { gap: "s" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_QrCode, { policy: policy.value }, null, 8, ["policy"])
    ])
  ]))
}
}

})